import api from "./axios";

const ConfigService = {
  getAll: async () => {
    try {
      const response = await api.get("/configs");
      return response.data;
    } catch (error) {
      console.error("Error fetching configs:", error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/configs/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching config ${id}:`, error);
      throw error;
    }
  },

  getByName: async (name) => {
    try {
      const response = await api.get(`/configs/name/${name}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching config ${name}:`, error);
      throw error;
    }
  },

  getValueByName: async (name) => {
    try {
      const response = await api.get(`/configs/value/${name}`);
      return response.data.value;
    } catch (error) {
      console.error(`Error fetching config value for ${name}:`, error);
      throw error;
    }
  },

  getAllAsObject: async () => {
    try {
      const response = await api.get("/configs/all-as-object");
      return response.data;
    } catch (error) {
      console.error("Error fetching configs as object:", error);
      throw error;
    }
  },

  create: async (configData) => {
    try {
      const response = await api.post("/configs", configData);
      return response.data;
    } catch (error) {
      console.error("Error creating config:", error);
      throw error;
    }
  },

  update: async (id, configData) => {
    try {
      const response = await api.patch(`/configs/${id}`, configData);
      return response.data;
    } catch (error) {
      console.error(`Error updating config ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/configs/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting config ${id}:`, error);
      throw error;
    }
  },
};

export default ConfigService;
